import Device from "util/device";
import { setUser } from "util/exception";
import { segmentIdentify, segmentReset } from "util/segment";

export function setUserTrackingContexts(id?: string | null) {
  if (id) {
    segmentIdentify(id);
  } else {
    segmentReset();
  }
  setUser({ deviceId: Device.identifier, id });
}
